import React, { useEffect, useState } from "react";
import { Loader2, ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const AdminParentalWaivers = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/admin/parental-waivers", { withCredentials: true });
        setItems(data);
      } catch {
        toast.error("Could not load waivers.");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="space-y-5" data-testid="admin-parental-waivers">
      <div>
        <h2 className="text-xl font-semibold text-slate-900 flex items-center gap-2">
          <ShieldCheck className="w-5 h-5 text-spike-blue" /> Parental Waiver Consents
        </h2>
        <p className="text-sm text-slate-600 mt-1">All signed waivers for minor users (under 18).</p>
      </div>

      {loading ? (
        <div className="py-12 flex justify-center"><Loader2 className="w-5 h-5 animate-spin text-spike-blue" /></div>
      ) : (
        <div className="bg-white border border-slate-200 rounded-lg overflow-hidden shadow-card">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-600 text-xs uppercase tracking-wider">
              <tr>
                <th className="text-left px-4 py-3">Parent / Guardian</th>
                <th className="text-left px-4 py-3">Kid Name</th>
                <th className="text-left px-4 py-3">Kid DOB</th>
                <th className="text-left px-4 py-3">Phone</th>
                <th className="text-left px-4 py-3">Agreed</th>
                <th className="text-left px-4 py-3">Signed at</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {items.map((w, i) => (
                <tr key={i} data-testid={`pw-row-${i}`} className="hover:bg-slate-50">
                  <td className="px-4 py-3 font-medium text-slate-900">{w.parent_name || "—"}</td>
                  <td className="px-4 py-3 text-slate-700">{w.kid_name}</td>
                  <td className="px-4 py-3 text-slate-700">{w.kid_dob || "—"}</td>
                  <td className="px-4 py-3 text-slate-700">{w.phone || "—"}</td>
                  <td className="px-4 py-3">
                    <span className="inline-flex items-center px-2.5 py-1 rounded-full bg-emerald-50 text-emerald-700 text-xs font-medium">
                      Yes ({w.version})
                    </span>
                  </td>
                  <td className="px-4 py-3 text-slate-500 text-xs">{w.signed_at ? new Date(w.signed_at).toLocaleString() : "—"}</td>
                </tr>
              ))}
              {items.length === 0 && (
                <tr><td colSpan={6} className="px-4 py-12 text-center text-slate-500">No parental waivers yet.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminParentalWaivers;
